<template>
  <section class="fundo">
    <v-container grid-list-md>
      <v-layout wrap>
        <v-flex xs6 md3 v-for="(o, i) in items" :key="i" class="item">
          <i :class="'icon fa-3x '+o.icon"></i>
          <h3 class="title font-weight-bold">{{o.title}}</h3>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    items: [
      { title: "Pensado para o convívio e interação", icon: "fas fa-heart" },
      { title: "Oferece conforto e segurança", icon: "fas fa-shield-alt" },
      {
        title: "Arborizado e permite o contato com a natureza",
        icon: "fas fa-tree"
      },
      {
        title: "Salas climatizadas e bem equipadas",
        icon: "fas fa-snowflake"
      },
      {
        title: "Favorece o estudo e o aprendizado",
        icon: "fas fa-chalkboard-teacher"
      },
      { title: "Sempre limpo e bem arejado", icon: "fas fa-sun" },
      {
        title: "Atenção especial para a acessibilidade",
        icon: "fas fa-wheelchair"
      },
      {
        title: "Localização privilegiada no Campeche",
        icon: "fas fa-map-marker-alt"
      }
    ]
  })
};
</script>

<style lang="scss" scoped>
@import url("//fonts.googleapis.com/css?family=Pacifico");

section {
  padding: 30px 0 10px 0;
}

.fundo {
  background-image: repeating-linear-gradient(
    -45deg,
    rgba(32, 150, 243, 0.8),
    rgba(32, 150, 243, 0.8) 5px,
    rgba(32, 150, 243, 1) 5px,
    rgba(32, 150, 243, 1) 10px
  );
}

.icon {
  color: rgba(255, 255, 255, 1);
}

h3 {
  color: #ffffff;
  margin: 5px 0 30px 0;
  font-size: 1.2em;
  line-height: 1.3em !important;
}

.item {
  text-align: center;
  text-shadow:1px 1px 3px #0C47A0;
}
</style>